/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateCodeResponseDto
 */
export interface ValidateCodeResponseDto {
    /**
     * Whether the code is valid (not already taken)
     * @type {boolean}
     * @memberof ValidateCodeResponseDto
     */
    isValid: boolean;
    /**
     * Validation message
     * @type {string}
     * @memberof ValidateCodeResponseDto
     */
    message: string;
}

/**
 * Check if a given object implements the ValidateCodeResponseDto interface.
 */
export function instanceOfValidateCodeResponseDto(value: object): value is ValidateCodeResponseDto {
    if (!('isValid' in value) || value['isValid'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ValidateCodeResponseDtoFromJSON(json: any): ValidateCodeResponseDto {
    return ValidateCodeResponseDtoFromJSONTyped(json, false);
}

export function ValidateCodeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateCodeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isValid': json['isValid'],
        'message': json['message'],
    };
}

export function ValidateCodeResponseDtoToJSON(value?: ValidateCodeResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isValid': value['isValid'],
        'message': value['message'],
    };
}

